const initialState = {
  revenue: null,
  top_products: [],
  buyer_geography: [],
  conversion_funnel: null,
  rfq_stats: null,
  avg_order_value: null,
  inventory_alerts: [],
  loaded: false,
};

export function sellerAnalytics(state = initialState, action) {
  switch (action.type) {
    case "GET_SELLER_ANALYTICS":
      return {
        ...state,
        revenue: action.payload.revenue,
        top_products: action.payload.top_products,
        buyer_geography: action.payload.buyer_geography,
        conversion_funnel: action.payload.conversion_funnel,
        rfq_stats: action.payload.rfq_stats,
        avg_order_value: action.payload.avg_order_value,
        inventory_alerts: action.payload.inventory_alerts,
        loaded: true,
      };
    default:
      return state;
  }
}
